import {createSlice} from "@reduxjs/toolkit";


const LikedSlice = createSlice({
    name: "LikedSlice",
    initialState: {
        liked: [],
        count: 0
    },
    reducers: {
        setLiked(state, action) {
            state.liked.push(action.payload);
            state.count = state.count + 1;
        },
        deleteLiked(state, action) {
            state.count = state.count - 1;
            state.liked.splice(action.payload, 1);
        }

    }
})


export const {setLiked,deleteLiked} = LikedSlice.actions;

export default LikedSlice.reducer;